module.exports = __webpack_public_path__ + "media/application/images/2023/02_still-1450x816-87546dcffb3395ee9f0b360ca913cf4f.png";